<template>
  <div class="animated fadeIn">
    <div v-if="loading">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-show="!loading">
      <div class="vx-row md:w-full lg:w-full sm:w-full mb-2">
        <div class="vx-col sm:w-full md:w-1/2">
          <router-link to="/bill-management" class="vx-row">
            <h4 class="routepath">
              <span class="primary">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" class="shift-2"
              /></span>
              <span class="secondary">{{ $t("billManagement.label.billing") }}</span>
            </h4>
          </router-link>
        </div>
        <div class="vx-card pl-6 pr-6 mt-3" style="min-height: 643px">
          <div class="vx-row">
            <div class="vx-col sm:w-full md:w-1/2 mt-4">
              <div class="grid grid-cols-4">
                <h4 class="font-semibold">{{ $t("billManagement.label.BillCycle") }}:</h4>
                <span>{{ data && data.id }}</span>
              </div>
            </div>
            <div class="vx-col sm:w-full md:w-1/2 text-right mt-5">
              <vs-button @click="onLoad">{{
                $t("billManagement.label.start")
              }}</vs-button>
            </div>
          </div>
          <div v-if="show">
            <stepProgressIndicator :orderDetailsData="orderDetailsData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import stepProgressIndicator from "../../components/stepProgressIndicator.vue";
import { AtomSpinner } from "epic-spinners";
export default {
  components: {
    stepProgressIndicator,
    AtomSpinner,
  },
  data() {
    return {
      loading: false,
      orderDetailsData: [
        {
          label: "Charging",
          status: "In Progress",
        },
        {
          label: "Invoicing",
          status: "Not Started",
        },
      ],
      data: "",
      show: false,
    };
  },
  methods: {
    async onLoad() {
      this.show = true;
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      try {
        this.orderDetailsData[0].status = "In Progress";
        await this.executeJob(44);
        this.orderDetailsData[0].status = "Complete";
        await delay(4000);
      } catch (error) {
        this.orderDetailsData[0].status = "Failed";
        return;
      }
      try {
        this.orderDetailsData[1].status = "In Progress";
        await this.executeTrialInvoice(40);
        this.orderDetailsData[1].status = "Complete";
        await delay(2000);
        this.$router.push("/bill-management");
      } catch (error) {
        this.orderDetailsData[0].status = "Failed";
        return;
      }
    },
    async executeJob(id) {
      await this.$store.dispatch("admin/executeJobsAction", id);
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Trial Charge Executed successfully!",
        type: "success",
      });
    },
    async executeTrialInvoice(id) {
      await this.$store.dispatch("admin/executeJobsAction", id);
      this.$swal({
        title: "Congratulations!",
        icon: "success",
        text: "Your Bill has been Successfully Generated...",
        type: "success",
      });
    },
  },
  mounted() {
    this.data = this.$route.params;
  },
};
</script>

<style></style>
